var _path, _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 181,
    viewBox: "0 0 196 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2221 0C57.4522 0 60.5297 1.24733 63.1191 3.17834C72.651 10.2865 84.7602 14.54 97.9404 14.54C111.121 14.54 123.231 10.2866 132.763 3.17837C135.352 1.24735 138.43 0 141.66 0H182.794C190.022 0 195.881 5.85918 195.881 13.0868V167.221C195.881 174.448 190.022 180.308 182.794 180.308H141.661C138.431 180.308 135.353 179.06 132.764 177.129C123.231 170.02 111.121 165.767 97.9404 165.767C84.7598 165.767 72.6502 170.02 63.1182 177.129C60.5287 179.06 57.4512 180.308 54.2209 180.308H13.0868C5.85918 180.308 0 174.448 0 167.221V13.0868C0 5.85918 5.85918 0 13.0868 0H54.2221Z",
    fill: "#FCF8F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.2614,
    cy: 90.3856,
    rx: 48.32,
    ry: 47.7318,
    fill: "#EC9832",
    fillOpacity: 0.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.528,
    cy: 90.649,
    rx: 35.2389,
    ry: 34.8099,
    fill: "#EC9832",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8109_27953)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0126 73.4742C92.5425 71.6424 95.8694 72.5338 102.523 74.3167C109.177 76.0995 112.504 76.9909 112.913 79.3422C112.948 79.5443 112.968 79.7499 112.973 79.9571C113.033 82.3667 109.987 84.3248 103.895 88.2409L99.8193 90.8468L102.046 95.1417C105.364 101.579 107.023 104.798 105.766 106.855C105.658 107.031 105.538 107.199 105.406 107.357C103.876 109.188 100.549 108.297 93.8957 106.514C87.2421 104.731 83.9152 103.84 83.5062 101.489C83.471 101.287 83.4508 101.081 83.4456 100.874C83.3854 98.4641 86.4314 96.5061 92.5233 92.59L96.5995 89.9841L94.3724 85.6892C91.0547 79.2518 89.3958 76.0331 90.6528 73.9763C90.7608 73.7995 90.8811 73.6316 91.0126 73.4742ZM92.5093 98.8095C91.8425 98.6308 91.157 99.0265 90.9784 99.6934C90.7997 100.36 91.1954 101.046 91.8622 101.224L98.3017 102.95C98.9686 103.128 99.654 102.733 99.8327 102.066C100.011 101.399 99.6156 100.714 98.9488 100.535L92.5093 98.8095ZM96.5861 78.765C96.7648 78.0982 97.4502 77.7024 98.117 77.8811L104.557 79.6066C105.223 79.7852 105.619 80.4707 105.44 81.1375C105.262 81.8043 104.576 82.2001 103.909 82.0214L97.47 80.2959C96.8032 80.1172 96.4074 79.4318 96.5861 78.765Z",
    fill: "#EC9832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8109_27953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(84.0664 65.9207) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingPending);
export default __webpack_public_path__ + "static/media/bookingPending.5a4fc9462ae7849a41216e8028965c51.svg";
export { ForwardRef as ReactComponent };